import {Action, Module, Mutation} from 'vuex-module-decorators';
import store from '@/store';
import {TimelineReplyModel} from '@/models/timeline.model';
import {take} from 'rxjs/operators';
import {EntityStateAdapter} from '@/store/base.store';
import {TimelineReplyApi} from '@/api/timeline-reply.api';

export const featureKey = 'timeline_reply';

// @ts-ignore
if (store.state.timeline_reply) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class TimelineRepliesStoreModule extends EntityStateAdapter<TimelineReplyModel> {

  get timelineReplies(): TimelineReplyModel[] {
    return this._entities;
  }

  get replies(): (interactionId: number) => TimelineReplyModel[] {
    return (interactionId: number) => {
      return this._entities.filter((v) => v.interaction_id === interactionId)
    }
  }

  get userAlreadyReplyThis(): (userId: number, interactionId: number) => boolean {
    return (userId, interactionId) => {
      return !!this._entities.filter((v) => v.user_id === userId && v.interaction_id === interactionId);
    }
  }

  @Action({commit: 'insertMany', rawError: true})
  async fetchAll(data: {
    challengerId: number,
    timelineId: number,
    interactionId: number
  }): Promise<TimelineReplyModel[]> {
    this.updateLoading(true);
    const response = await new TimelineReplyApi(data.challengerId, data.timelineId, data.interactionId)
      .allPaginated()
      .pipe(take(1))
      .toPromise();
    this.context.commit('updateAllPageParams', response);
    return response.data;

  }

  @Mutation
  addReply(reply: TimelineReplyModel): void {
    const index = this._entities.findIndex((v) => v.id === reply.id);
    if (~index) {
      this._entities.splice(index, 1, reply);
    } else {
      this._entities.push(reply);
    }
  }

  @Mutation
  replyDeleted(replyId: number): void {
    const index = this._entities.findIndex((v) => v.id === replyId);
    if (~index) {
      this._entities.splice(index, 1);
    }
  }

  @Action({commit: 'addReply', rawError: true})
  async createReply(data: {
    challengeId: number,
    timelineId: number,
    interactionId: number
    payload: TimelineReplyModel,
  }): Promise<TimelineReplyModel> {
    const timelineReplyApi = new TimelineReplyApi(data.challengeId, data.timelineId, data.interactionId);
    return await timelineReplyApi.create(data.payload).pipe(take(1)).toPromise();
  }

  @Action({commit: 'addReply', rawError: true})
  async editReply(data: {
    challengeId: number,
    interactionId: number,
    timelineId: number,
    payload: TimelineReplyModel,
  }): Promise<TimelineReplyModel> {
    const timelineReplyApi = new TimelineReplyApi(data.challengeId, data.timelineId, data.interactionId);
    return await timelineReplyApi.update(data.payload).pipe(take(1)).toPromise();
  }


  @Action({commit: 'replyDeleted', rawError: true})
  async deleteReply(data: {
    challengeId: number,
    interactionId: number,
    timelineId: number,
    replyId: number,
  }): Promise<number> {
    const timelineApi = new TimelineReplyApi(data.challengeId, data.timelineId, data.interactionId);
    await timelineApi.destroy(data.replyId).pipe(take(1)).toPromise();
    return data.replyId
  }

  @Action({commit: 'insertMany', rawError: true})
  resetAllReplies() {
    return []
  }
}
